import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagPW(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURVGx2P/fO1e33ly85GLD62DB6GTG7rXPhenbU5DGq7abpDgAAAG4SURBVDjL3ZOxbtswEIavfAOlg52NIIc2myuCSLJ5oDwbkIikmwcic+KgD9ApGdsCRvO4uf9IS1RrJHt+m+Tx/u/uLAGmu7e1o3eBlNLdJqXNJE7nPXB2RxylFDaBtRGQbwEr39eEKCTcBJKbIMKEHYVKKfynNYW3taYhhK4bhnLvylEyXbelgcVBjNN53LG2FLOGgbe/z8unQ76WdBwB6KGBfsRaNfAifrM8zIEeij7GGzZ/8qdZxCgZyW7Jg/MM5QEyxHtkJLsi73rnet9/H/3mvPfsYTm/IudZDN3KBNmWqJHlHTpIUCYI0jy6HtUo3JIraip9dqNWR+C6Bs5PAJc1sDgBXNXAsgZs66y17RxoR62IfcfBtxpokHMoZcBweWvtvx2MQd+21SSxab/OADEt561GB/btl9lTGNPCNehgjehi9h7YR18WdyiqgbNi2xp4qIC9GTUBnyrAnAIu6p9QA9ooLWuasVeQziL28nd80IWWUl5KOgBGB/pdgD8oRA94mhBIqCgPuSdYKNF8EunjLI7xz/olviJUSZ4QkmRJBFbJTkosoZVYVJCyZ3/MqBJMTenj6BUs6ecUo7+BqgAAAABJRU5ErkJggg==",
    alt: "PW"
  }, props));
}